module.exports = __webpack_public_path__ + "static/media/3. Restos, Resina cristal y hojas de árbol, 20 x 20 x 9 cm, 2019 copy.f23ac636.png";